export default __webpack_public_path__ + "static/media/elevation--240.96072aea.jpg";